<section class="paddingTopBottom">
  <section class="row">
    <div class="col-md-12 acc-ovrvw-ntfcntns-bnr text-center">
      <h3 class="notification-hdng">Notifications</h3>
      <p class="accOvrvw-ntfctn-msg" style="text-align:center">Check here for a complete record of your transactions,
        shipments, invoices and payments, account changes and more.</p>
      <button type="button" class="btn-secondary" (click)="viewNotification()">View
        notifications</button>
    </div>
  </section>
</section>